import styled from "styled-components";

import { colors, radii, shadows } from "shared/ui/tokens";

import { COMPACT_TILE_BREAKPOINT } from "features/MenuEditor/styles";

// Рамки у позиции в стоп-листе нет намеренно (в хендоффе она есть): её 2px габарита
// сдвигали бы соседей при каждом переключении тумблера.
export const Card = styled.article`
    display: flex;
    flex-direction: column;
    /* Растягиваемся на всю высоту строки сетки — иначе прижимать футер не к чему. */
    height: 100%;
    border-radius: ${radii.base};
    background: ${colors.surface};
    box-shadow: ${shadows.panel};
    overflow: hidden;
`;

// Забирает свободное место карточки, поэтому тумблеры в ряду стоят на одной высоте
// независимо от длины названия и описания.
export const Clickable = styled.div<{ $stopped: boolean }>`
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    min-height: 0;
    cursor: pointer;
    opacity: ${({ $stopped }) => ($stopped ? 0.7 : 1)};
`;

/*
* Фото задано пропорцией, а не фиксированной высотой. Высота в пикселях не зависела от
* ширины карточки, и на промежуточных ширинах (две колонки на планшете) карточка
* растягивалась, а фото оставалось низким — блюдо выглядело расплющенным.
* 66% ≈ 3:2 — ровно та пропорция, что в макете на обоих краях: 170px при карточке ~252px
* на 1440 и 110px при карточке ~173px на 390.
* */
export const Photo = styled.div`
    position: relative;
    flex: none;
    width: 100%;
    padding-top: 66%;
    background: ${colors.segmentBg};

    img,
    video {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
    }
`;

export const NoPhoto = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
    color: rgba(0, 0, 0, 0.38);
    font-size: 12px;

    svg {
        font-size: 28px;
    }
`;

export const StopBadge = styled.span`
    position: absolute;
    top: 8px;
    left: 8px;
    padding: 3px 8px;
    border-radius: ${radii.badge};
    background: ${colors.danger};
    color: #fff;
    font-size: 11px;
    font-weight: 600;
`;

export const Body = styled.div`
    /* Свободное место копится здесь, под текстом, а не перед футером. */
    flex: 1 1 auto;
    padding: 12px 14px 14px;
`;

export const TitleRow = styled.div`
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 10px;
`;

export const Title = styled.h3`
    margin: 0;
    font-size: 15px;
    font-weight: 600;
    color: ${colors.textPrimary};
    /* Название в две строки максимум: иначе плитки в ряду разной высоты. */
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
`;

export const Price = styled.span`
    flex: none;
    font-size: 15px;
    font-weight: 700;
    color: ${colors.textPrimary};
    white-space: nowrap;
`;

export const Description = styled.p`
    margin: 6px 0 0;
    font-size: 13px;
    line-height: 1.4;
    color: ${colors.textSecondary};
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;

    @media (max-width: ${COMPACT_TILE_BREAKPOINT - 1}px) {
        display: none;
    }
`;

export const Meta = styled.p<{ $muted: boolean }>`
    margin: 6px 0 0;
    font-size: 12px;
    color: ${({ $muted }) => ($muted ? "rgba(0,0,0,0.38)" : colors.textSecondary)};
`;

export const Footer = styled.footer`
    flex: none;
    padding: 10px 14px;
    border-top: 1px solid ${colors.borderSoft};
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
`;
